module.exports = __webpack_public_path__ + "img/keder_silbergrau_ral9006.0fa75565.jpg";